
import image0 from "gallery-image:featured:plane";
import image1 from "gallery-image:featured:building";
import image2 from "gallery-image:featured:street";
import image3 from "gallery-image:featured:suj1";
import image4 from "gallery-image:featured:tired";
import image5 from "gallery-image:featured:window";
import image6 from "gallery-image:featured:boribap";
import image7 from "gallery-image:featured:bed";
import image8 from "gallery-image:featured:tunnel3";

const images = { 'plane': image0,
'building': image1,
'street': image2,
'suj1': image3,
'tired': image4,
'window': image5,
'boribap': image6,
'bed': image7,
'tunnel3': image8,
 };
export default {
  ...{"id":"featured","title":"Featured"},
  tiles: [ {
  color: "gray",
  size: "large",
  position: "left",
  lift: false,
  image: images["plane"]
}, 
{
  color: "yellow",
  size: "medium",
  position: "far-right",
  lift: false,
  image: images["building"]
}, 
{
  color: "blue",
  size: "large",
  position: "far-left",
  lift: true,
  image: images["street"]
}, 
{
  color: "purple",
  size: "x-large",
  position: "left",
  lift: false,
  image: images["suj1"]
}, 
{
  color: "blue",
  size: "large",
  position: "far-left",
  lift: false,
  image: images["tired"]
}, 
{
  color: "blue",
  size: "x-large",
  position: "far-right",
  lift: false,
  image: images["window"]
}, 
{
  color: "green",
  size: "large",
  position: "left",
  lift: false,
  image: images["boribap"]
}, 
{
  color: "purple",
  size: "large",
  position: "far-right",
  lift: false,
  image: images["bed"]
}, 
{
  color: "orange",
  size: "x-large",
  position: "far-left",
  lift: false,
  image: images["tunnel3"]
} ]
};
